import s from './Badge.css';
import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';

export default function Badge({ children, variant }) {
    useStyles(s);

    let classNamePostfix = ` ${s.primary}`;
    if (typeof variant !== 'undefined' && typeof s[variant] != 'undefined') {
        classNamePostfix = ` ${s[variant]}`;
    }

    return (
        <span className={s.badge + classNamePostfix}>{children}</span>
    );
}